<p-galleria
  #galleria
  [value]="slides"
  [showIndicators]="true"
  [showIndicatorsOnItem]="true"
  indicatorsPosition="bottom"
  [containerStyle]="{ width: '100%' }"
  maskClass="overflow-auto align-items-start z-dialog"
  (activeIndexChange)="onSlide($event)"
  (visibleChange)="onClose()"
  [visible]="galleriaVisible"
  [circular]="true"
  [fullScreen]="true"
  [showThumbnailNavigators]="false"
  [showItemNavigators]="true">
  <ng-template pTemplate="item">
    <div class="galleria-overlay">
      <div class="galleria-content">
        <app-atlas-grid
          [bookmark]="content()"
          id="story"
          [forceReadOnly]="true"></app-atlas-grid>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="caption" let-item>
    <div class="absolute top-0 right-0 flex gap-2 mt-2">
      <p-button
        (click)="openBookmark(item, false)"
        pTooltip="Bericht schließen und Slide öffnen (gleicher Tab)"
        styleClass="p-button-xs"
        [rounded]="true"
        icon="fa-solid fa-eye"></p-button>
      <p-button
        styleClass="p-button-xs"
        [rounded]="true"
        pTooltip="Ansicht öffnen (neuer Tab)"
        icon="fas fa-arrow-up-right-from-square"
        (click)="openBookmark(item, true)"></p-button>
      <p-button
        styleClass="p-button-xs"
        [rounded]="true"
        pTooltip="Bericht teilen (Link kopieren)"
        icon="fa-solid fa-share-nodes"
        (click)="copyStoryLink(story._id)"></p-button>
      <p-button
        (click)="slideMenu.toggle($event)"
        styleClass="p-button-xs"
        [rounded]="true"
        icon="fa-solid fa-bars"></p-button>
      <p-button
        (click)="close()"
        styleClass="p-button-xs"
        [rounded]="true"
        icon="fa-solid fa-xmark"></p-button>
      <p-menu [model]="slideMenuItems" #slideMenu [popup]="true" />
    </div>
    <div class="flex flex-column gap-2">
      <app-header styleClass="m-0" [text]="item.title"></app-header>
      <div class="flex gap-2 align-items-center">{{ story.title }}</div>
    </div>
  </ng-template>
</p-galleria>
